import * as React from 'react';
import { UitkToast } from 'uitk-react-toast';

interface NotificationProps {
  message: string;
}

export const Notification = ({ message }: NotificationProps) => <UitkToast show={!!message}>{message}</UitkToast>;

Notification.displayName = 'Notification';
